var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M61.666 7.5l3.333 3.333L68.333 7.5l-3.334-3.333L61.666 7.5zm-57.5 26.667l2.5 2.5 2.5-2.5-2.5-2.5-2.5 2.5zm66.668 10h2.5v-2.5h-2.5v2.5z",
    fill: "#76808F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.999,
    cy: 39.167,
    r: 3.333,
    fill: "url(#paint0_linear_1288_32024)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M30 45l10 10 10-10v25H30V45z",
    fill: "#76808F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 45h-6.667C15.97 45 10 50.97 10 58.333V70h20V45z",
    fill: "url(#paint1_linear_1288_32024)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50 45v25h20V58.333C70 50.97 64.03 45 56.667 45H50z",
    fill: "url(#paint2_linear_1288_32024)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 20c0-6.903 5.596-12.5 12.5-12.5 6.903 0 12.5 5.597 12.5 12.5v1.667h3.333V20c0-8.745-7.09-15.833-15.834-15.833S24.166 11.255 24.166 20v1.667h3.333V20z",
    fill: "url(#paint3_linear_1288_32024)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.167 29.881c0 2.367-1.99 4.286-4.445 4.286H52.5V21.25h2.222c2.455 0 4.445 1.919 4.445 4.286v4.345z",
    fill: "url(#paint4_linear_1288_32024)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.833 29.881c0 2.367 1.99 4.286 4.445 4.286H27.5V21.25h-2.222c-2.455 0-4.445 1.919-4.445 4.286v4.345z",
    fill: "url(#paint5_linear_1288_32024)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1288_32024",
    x1: 39.999,
    y1: 35.833,
    x2: 39.999,
    y2: 42.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D33A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1288_32024",
    x1: 40,
    y1: 70,
    x2: 40,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76808F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#929AA5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1288_32024",
    x1: 40,
    y1: 70,
    x2: 40,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76808F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#929AA5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1288_32024",
    x1: 39.999,
    y1: 4.167,
    x2: 39.999,
    y2: 21.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76808F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1288_32024",
    x1: 55.833,
    y1: 34.167,
    x2: 55.833,
    y2: 21.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D33A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1288_32024",
    x1: 24.167,
    y1: 34.167,
    x2: 24.167,
    y2: 21.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D33A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCs);
export default __webpack_public_path__ + "static/media/cs.1c21dc9ace019ed86c2562cdf5b9dc04.svg";
export { ForwardRef as ReactComponent };